import { render, staticRenderFns } from "./taskFilesTabNew.vue?vue&type=template&id=ac15ef76&scoped=true&"
import script from "./taskFilesTabNew.vue?vue&type=script&lang=js&"
export * from "./taskFilesTabNew.vue?vue&type=script&lang=js&"
import style0 from "./taskFilesTabNew.vue?vue&type=style&index=0&id=ac15ef76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac15ef76",
  null
  
)

export default component.exports